import { alpha, Avatar, Box, IconButton, styled } from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import CloseIcon from '@mui/icons-material/Close';
import type { AlphaFeedToastVariant } from './AlphaFeedToast';

/** Neutral toast fill (Figma #3b3c46 at 20%, raised for legibility; no palette token). */
const NEUTRAL_TOAST_BG = alpha('#3b3c46', 0.7);

export const ToastRoot = styled(Box, { shouldForwardProp: (prop) => prop !== 'variant' })<{
    variant: AlphaFeedToastVariant;
}>(({ theme, variant }) => {
    const { primitives } = theme.palette;
    return {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        width: '100%',
        padding: '12px',
        backgroundColor: variant === 'error' ? primitives.thunderbird[1000] : NEUTRAL_TOAST_BG,
        border: `1px solid ${alpha(primitives.base.white, 0.1)}`,
        borderRadius: '6px',
        boxShadow: '0px 1px 12px 0px rgba(25, 27, 35, 0.15)',
        pointerEvents: 'auto',
    };
});

export const ToastErrorIcon = styled(HighlightOffOutlinedIcon)(({ theme }) => ({
    flexShrink: 0,
    fontSize: '24px',
    color: theme.palette.primitives.thunderbird[500],
}));

export const ToastIconSlot = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '24px',
    height: '24px',
});

export const ToastCoinIcon = styled(Avatar)({
    flexShrink: 0,
    width: '24px',
    height: '24px',
    fontSize: '12px',
});

export const ToastText = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: '1 1 auto',
    minWidth: 0,
});

export const ToastCloseButton = styled(IconButton)({
    flexShrink: 0,
    padding: 0,
});

export const ToastCloseIcon = styled(CloseIcon)(({ theme }) => ({
    fontSize: '16px',
    color: theme.palette.primitives.base.white,
}));
